import React, { useState } from 'react';
import './Tabs.scss';

const Tabs = () => {
  const [activeTab, setActiveTab] = useState('characteristics');

  return (
    <div className="tabs">
      <div className="tab-buttons">
        <button
          className={activeTab === 'characteristics' ? 'active' : ''}
          onClick={() => setActiveTab('characteristics')}
        >
          Characteristics
        </button>
        <button
          className={activeTab === 'specifications' ? 'active' : ''}
          onClick={() => setActiveTab('specifications')}
        >
          Specifications
        </button>
      </div>
      <div className="tab-content">
        {activeTab === 'characteristics' && (
          <div>
            <h3>Characteristics</h3>
            <p>Details about the product characteristics.</p>
          </div>
        )}
        {activeTab === 'specifications' && (
          <div>
            <h3>Specifications</h3>
            <p>Details about the product specifications.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Tabs;